module.exports = __webpack_public_path__ + "static/media/brad316_1596517957311.7b607a88.png";